import { motion } from "framer-motion";
import { FaWhatsapp } from "react-icons/fa";
import { BRAND } from "@/lib/config";

export default function Nav() {
  return (
    <motion.header
      initial={{ opacity: 0, y: -12 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.8, delay: 0.2, ease: [0.22, 1, 0.36, 1] }}
      className="fixed top-0 left-0 right-0 z-40 bg-cream/70 backdrop-blur-xl border-b border-ink/10"
      data-testid="site-nav"
    >
      <div className="max-w-[1440px] mx-auto px-6 sm:px-10 py-4 flex items-center justify-between">
        <a href="#top" className="font-serif text-xl sm:text-2xl tracking-tight" data-testid="nav-logo">
          Wonder<span className="italic text-terracotta">Time</span>
        </a>
        <div className="flex items-center gap-3">
          <a
            href="#pricing"
            className="hidden sm:inline-block text-sm uppercase tracking-[0.18em] font-semibold text-ink/70 hover:text-ink transition-colors"
            data-testid="nav-pricing-link"
          >
            Pricing
          </a>
          <a
            href={BRAND.whatsappUrl}
            target="_blank"
            rel="noopener noreferrer"
            className="inline-flex items-center gap-2 rounded-full border border-ink/20 px-4 py-2 text-sm font-semibold hover:bg-ink hover:text-cream transition-colors"
            data-testid="nav-whatsapp-cta"
          >
            <FaWhatsapp className="text-whatsapp text-base" />
            <span className="hidden sm:inline">Chat with us</span>
          </a>
        </div>
      </div>
    </motion.header>
  );
}
